'use client';

import { FC, ReactElement } from 'react';
import { Box } from '@mui/material';
import { isEmptyPhrase } from '@/utils/phrases/isEmptyPhrase';
import { usePhrase } from '@/hooks/general/usePhrase/usePhrase';

import styles from '@/styles/modules/Socialbar.module.css';

interface SocialBarProps {
    socialMedias: Array<{ name: string; url: string; icon: ReactElement; title: number }>;
}

export const SocialBar: FC<SocialBarProps> = ({ socialMedias }: SocialBarProps) => {
    const { t } = usePhrase();

    return (
        <Box
            className={`${styles.socialbar} socialbar`}
            sx={{ justifyContent: { xs: 'center', md: 'flex-start' } }}
        >
            {socialMedias &&
                socialMedias.map((item, index) => {
                    if (!isEmptyPhrase(item.url)) {
                        return (
                            <Box className={styles.socialbarItem} key={index}>
                                <a
                                    className={`${styles.socialbarLink} socialIconLink`}
                                    data-testid={`${item.name}-link`}
                                    target="_blank"
                                    rel="noreferrer"
                                    title={t(item.title, { asString: true })}
                                    href={item.url}
                                >
                                    {item.icon}
                                </a>
                            </Box>
                        );
                    }
                })}
        </Box>
    );
};
